// src/components/.../Footer.jsx
import React, { useState } from "react";
import logo from "../../../assets/images/logo.png";
import { useTranslation } from "react-i18next";
import { sendContactMessage } from "src/redux/authSlice";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

function Footer() {
  const { t } = useTranslation();
  const today = new Date();
  const dispatch = useDispatch();
  const { contactLoading } =
    useSelector((state) => state.auth || state.client || {});

  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email || !message) return;
    dispatch(sendContactMessage({ email, message }));
    setEmail("");
    setMessage("");
  };

  return (
    <footer
      className="footer footercx"
      style={{ padding: "10px 0", zIndex: 999 }}
    >
      <section>
        <div className="container mt-3">
          <div className="mt-3 row gy-2 gy-md-3 justify-content-between">
            {/* logo */}
            <div className="col-12 col-md-4 col-lg-3 col-xl-2">
              <div className="widget">
                <a href="#!">
                  <img alt="logo-clicclaim" width={120} src={logo} />
                </a>
              </div>
            </div>

            {/* Contact us bloc */}
            <div className="col-12 col-md-4 col-lg-3 col-xl-2">
              <div className="widget">
                <h4
                  className="widget-title text-white mb-2"
                  style={{ fontSize: "14px" }}
                >
                  {t("Contact Us")}
                </h4>

                <p className="mb-1">
                  <a
                    className="link-secondary text-decoration-none text-white"
                    href="tel:+21653278286"
                    style={{ fontSize: "12px" }}
                  >
                    +216 53 27 82 86
                  </a>
                </p>
                <p className="mb-1">
                  <a
                    className="link-secondary text-decoration-none text-white"
                    href="tel:+33753157294"
                    style={{ fontSize: "12px" }}
                  >
                    +33 7 53 15 72 94
                  </a>
                </p>

                <p className="mb-0">
                  <a
                    className="link-secondary text-decoration-none text-white"
                    href="mailto:cliclaim@cliclaim.com"
                    style={{ fontSize: "12px" }}
                  >
                    cliclaim@cliclaim.com
                  </a>
                </p>
              </div>
            </div>

            {/* Learn more bloc */}
            <div className="col-12 col-md-4 col-lg-3 col-xl-2 justify-content-start align-items-start">
              <div className="widget">
                <h4 className="widget-title text-white mb-2">
                  {t("Learn More")}
                </h4>
                <ul className="list-unstyled">
                  <li className="mb-1">
                    <Link
                      to="/about"
                      className="link-secondary text-decoration-none text-white"
                      style={{ fontSize: "12px" }}
                    >
                      {t("nav.about")}
                    </Link>
                  </li>

                  <li className="mb-1">
                    <Link
                      to="/terms"
                      className="link-secondary text-decoration-none text-white"
                      style={{ fontSize: "12px" }}
                    >
                      {t("nav.terms")}
                    </Link>
                  </li>

                  <li className="mb-0">
                    <Link
                      to="/privacy"
                      className="link-secondary text-decoration-none text-white"
                      style={{ fontSize: "12px" }}
                    >
                      {t("nav.privacy")}
                    </Link>
                  </li>
                </ul>
              </div>
            </div>

            {/* Formulaire de contact */}
            <div className="col-12 col-lg-3 col-xl-4">
              <div className="widget">
                <h4
                  className="widget-title text-white mb-2"
                  style={{ fontSize: "14px" }}
                >
                  {t("Contact")}
                </h4>
                <p className="mb-2 text-white" style={{ fontSize: "12px" }}>
                  {t("Leave your message.")}
                </p>
                <form onSubmit={handleSubmit}>
                  <div className="row gy-2">
                    <div className="col-12">
                      <div className="input-group">
                        <input
                          type="email"
                          className="w-100 input_login"
                          placeholder={t("Email Address")}
                          required
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          style={{
                            color: "#fff",
                            fontWeight: "bold",
                            fontSize: "12px",
                          }}
                        />
                        <textarea
                          className="w-100 input_login mt-2"
                          placeholder={t("Your Message")}
                          required
                          value={message}
                          onChange={(e) => setMessage(e.target.value)}
                          style={{
                            paddingTop: 10,
                            color: "#fff",
                            fontWeight: "bold",
                            height: 60,
                            fontSize: "12px",
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-12 mt-2">
                      <button
                        className="order_online3 w-100"
                        type="submit"
                        disabled={contactLoading}
                      >
                        {contactLoading ? t("Sending...") : t("Send")}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Copyright */}
      <div className="container justify-content-center align-items-center">
        <div className="d-flex gy-2 gy-md-0 justify-content-md-between align-items-center">
          <div className="col-md-12 order-1 order-md-0 text-center text-md-start">
            <div
              className="d-flex justify-content-center align-items-center copyright text-white text-center"
              style={{ fontSize: "10px", marginTop: 10 }}
            >
              © {today?.getFullYear()} &nbsp;
              <span style={{ color: "#1fc17d" }}>C</span>li
              <span style={{ color: "#1fc17d" }}>C</span>laim.&nbsp;
              {t("All Rights Reserved.")}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
